import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, output, ChangeDetectionStrategy } from '@angular/core';

import { DateService, Store } from '@softline/core';
import { DynamicModule, WithDefinition } from '@softline/dynamic';
import { SOFTLINE_DEFINITION_ARBEITSBERICHT_LIST } from '../../arbeitsbericht.api';
import { TimeReport } from '../../models/time-report.model';
import { TimeReportsService } from '../../services/time-reports.service';
import { FormatPipe } from '@softline/ui-core';
import { LoadingSpinnerComponent } from '@softline/ui-core';
@Component({
  selector: 'soft-time-report-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, DynamicModule,
    FormatPipe,
    LoadingSpinnerComponent] })
export class ListComponent extends WithDefinition(
  SOFTLINE_DEFINITION_ARBEITSBERICHT_LIST
) {
  private dateService = inject(DateService);
  private timeReportService = inject(TimeReportsService);

  date = input(this.dateService.now());

  all = this.timeReportService.value;
  loading = this.timeReportService.isLoading;

  selectedChange = output<TimeReport>();

  readonly totalTime = computed(() => {
    return this.timeReportService.sum();
  });

  override async ngOnInit(): Promise<void> {
    super.ngOnInit();
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  constructor(private store: Store) {
    super();
  }
}
